import React, { createContext, useContext, useState, useEffect } from "react";
import { apiClient } from "@/lib/api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(() => {
    const raw = localStorage.getItem("drc_user");
    return raw ? JSON.parse(raw) : null;
  });
  const [token, setToken] = useState(() => localStorage.getItem("drc_token"));
  const [ready, setReady] = useState(false);

  useEffect(() => {
    setReady(true);
  }, []);

  const login = async (username, password) => {
    const { data } = await apiClient.post("/auth/login", { username, password });
    localStorage.setItem("drc_token", data.token);
    localStorage.setItem("drc_user", JSON.stringify(data.user));
    setToken(data.token);
    setUser(data.user);
    return data.user;
  };

  const logout = async () => {
    try { await apiClient.post("/auth/logout"); } catch (e) { console.warn("Logout request failed (clearing local session anyway):", e?.message || e); }
    localStorage.removeItem("drc_token");
    localStorage.removeItem("drc_user");
    setToken(null);
    setUser(null);
  };

  const refreshUser = (patch) => {
    const next = { ...(user || {}), ...patch };
    setUser(next);
    localStorage.setItem("drc_user", JSON.stringify(next));
  };

  return (
    <AuthContext.Provider value={{ user, token, ready, login, logout, refreshUser }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
